module.exports = __webpack_public_path__ + "static/media/elephant_regular-min.d327db1d.jpg";